import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * Orunal Logo Component
 * A pure CSS-based logo with green gradient and upward growth arrow
 * Fully responsive and reusable across projects
 * 
 * @param {Object} props
 * @param {number|object} props.fontSize - Font size for the logo text (default: { xs: "40px", sm: "48px", md: "48px" })
 * @param {boolean} props.showUnderline - Whether to show the underline (default: true)
 * @param {number|object} props.spacing - Margin bottom spacing (default: { xs: 2, sm: 2.5 })
 */
export const OrunalLogo = ({ 
  fontSize = { xs: "40px", sm: "48px", md: "48px" },
  showUnderline = true,
  spacing = { xs: 2, sm: 2.5 }
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: spacing,
        position: "relative",
        width: "100%",
        paddingTop: { xs: "30px", sm: "40px", md: "45px" },
      }}
    >
      {/* Checkmark Symbol */}
      <Box
        sx={{
          position: "absolute",
          top: { xs: "5px", sm: "5px", md: "5px" },
          left: { xs: "50%", sm: "50%", md: "50%" },
          transform: "translateX(-50%) rotate(-45deg)",
          zIndex: 2,
        }}
      >
        {/* Checkmark using CSS borders */}
        <Box
          sx={{
            width: { xs: "12px", sm: "18px", md: "22px" },
            height: { xs: "24px", sm: "35px", md: "42px" },
            borderRight: { xs: "4px solid #228B22", sm: "6px solid #228B22", md: "7px solid #228B22" },
            borderBottom: { xs: "4px solid #228B22", sm: "6px solid #228B22", md: "7px solid #228B22" },
            borderRadius: "0 0 4px 0",
            filter: "drop-shadow(0 4px 8px rgba(34, 139, 34, 0.5))",
          }}
        />
      </Box>
      
      {/* Orunal Text Logo */}
      <Typography
        sx={{
          fontSize: fontSize,
          fontWeight: 900,
          fontFamily: "'Arial Black', 'Arial Bold', Gadget, sans-serif",
          letterSpacing: "-2px",
          background: "linear-gradient(180deg, #3CB371 0%, #228B22 50%, #1a6b1a 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
          textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
          position: "relative",
          lineHeight: 1,
        }}
      >
        Orunal
      </Typography>
      
      {/* Subtle underline effect
      {showUnderline && (
        <Box
          sx={{
            width: "100%",
            height: "3px",
            background: "linear-gradient(90deg, transparent 0%, #228B22 50%, transparent 100%)",
            marginTop: "4px",
            borderRadius: "2px",
            boxShadow: "0 2px 4px rgba(107, 142, 35, 0.3)",
          }}
        />
      )} */}
    </Box>
  );
};

export default OrunalLogo;
